import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDownload, doDelete } from './utils'

// ---------------------------------- หน้าแรกตั้งค่าผู้ใช้งาน
export const getUserSettingPageSchema = () => {
  const url = `${API_ROOT}/subproject/users-setting`
  return doGet(url)
}

export const getUserByUsername = (username) => {
  const url = `${API_ROOT}/subproject/users-setting/${username}`
  return doGet(url)
}

export const searchUserSetting = (request) => {
  const url = `${API_ROOT}/subproject/users-setting/search`
  return doPost(url, request)
}

export const saveUserSetting = (request) => {
  const url = `${API_ROOT}/subproject/users-setting/save`
  return doPost(url, request)
}

export const deleteUserSetting = (username) => {
  const url = `${API_ROOT}/subproject/users-setting/delete/${username}`
  return doDelete(url)
}
// ----------------------------------
